import React, { useMemo } from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";
import { usePageData } from "@insightfulscience/smart-react/hocs/DiPageHoC";
import FormFooter, { FormFooterCol } from "@insightfulscience/atomic-react/r1/molecules/FormFooter";
import { FormSubmit } from "@insightfulscience/atomic-react/r1/atoms/FormSubmit";
import useFormAction from "@insightfulscience/smart-react/hooks/useFormAction";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import QuoteFormFields from "./QuoteFormFields";
import { requestQuote } from "./action";
import { getInitialState } from "./form";
import { useCountries } from "../countries";

const QuoteForm = () => {
	const [t] = useLocale("quote-form");
	const [action, { isLoading }] = useFormAction(requestQuote);
	const { customer } = usePageData();
	const [, countryById] = useCountries();
	const initialState = useMemo(() => getInitialState(customer, countryById), [customer]);

	return (
		<>
			{isLoading && <Spinner />}
			<QuoteFormFields initialState={initialState} action={action}>
				<FormFooter>
					<FormFooterCol textAlign="left">
						<FormSubmit submitQASelector="quote-form-submit-btn">{t("REQUEST")}</FormSubmit>
					</FormFooterCol>
				</FormFooter>
			</QuoteFormFields>
		</>
	);
};

export default QuoteForm;
